<template>
  <component :is="tag" :class="[classes]"
  >
    <slot/>
  </component>
</template>

<script>

export default {
  name: 'VCardSubtitle',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
  computed: {
    classes () {
      return {
        'v-card__subtitle': true,
      }
    },
  }
};
</script>
